import type { CheckImportResult } from '@internal/backstage-plugin-pulse-common';
import { ImportResultBanner } from '../import-result-banner';

type CheckImportResultBannerProps = {
  result: CheckImportResult;
  onDismiss: () => void;
};

export const CheckImportResultBanner = ({
  result,
  onDismiss,
}: CheckImportResultBannerProps) => (
  <ImportResultBanner result={result} itemLabel="Check" onDismiss={onDismiss} />
);
